import React, { useEffect, useState } from "react";
import cookie from "react-cookies";

import { CONSTANTS, SOCIAL, NOTIFY } from "../based/Constants";
import LoadingR from "../based/LoadingR";
import AccountServices from "../based/services/AccountServices";
import Common from "../based/Common";
import { Notify } from "../based/Notify";

function LoginCallback(props) {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchUserInfo();
        loginWithFacebook();
    }, []);

    const fetchUserInfo = async () => {
        setIsLoading(true);
        let url = window.location.href;
        let idx = url.indexOf("?");
        let param = `?`;
        let state = "";
        if (idx >= 0) {
            let params = url.slice(idx, url.length);
            let urlSearchParams = new URLSearchParams(params);
            state = urlSearchParams.get("state");
            param += `code=${urlSearchParams.get("code")}`;
            param += `&state=${state}`;
            param += `&code_challenge=${urlSearchParams.get("code_challenge")}`;
        }
        let platform = state.split("-")[0];
        let social = SOCIAL.Undefined;
        switch (platform) {
            case "zalo":
                social = SOCIAL.Zalo;
                break;
            case "tiktok":
                social = SOCIAL.Tiktok;
                break;
            default:
                break;
        }
        if (social != SOCIAL.Undefined) {
            const [err, data] = await AccountServices.LoginSocial(param, social, "", "https://ranus.vn");
            if (!err && data) {
                let res = JSON.parse(data);
                let today = new Date();
                let expireDay = new Date();
                expireDay.setDate(today.getDate() + 365);
                cookie.save("token", res.token, { path: "/", expires: expireDay });
                let redirect = localStorage.getItem(CONSTANTS.LOGIN_URL_CALLBACK);
                setIsLoading(false);
                window.location.href = redirect ? redirect : "/";
            }
        }
        setIsLoading(false);
    };

    async function loginWithFacebook() {
        setIsLoading(true);
        let fullParamUrl = window.location.search;
        if (fullParamUrl && fullParamUrl.indexOf("code=") > -1 && fullParamUrl.indexOf("state=facebook") > -1) {
            let ruuid = "";
            let redirect = localStorage.getItem(CONSTANTS.LOGIN_URL_CALLBACK);
            if (redirect && redirect.length > 0) {
                redirect = redirect.replace("?redirect=", "");
            } else redirect = "/";
            const [err, data] = await AccountServices.LoginSocial(fullParamUrl, SOCIAL.Facebook, ruuid, redirect);
            if (!err && data) {
                let response = JSON.parse(data);
                if (response) {
                    let today = new Date();
                    let expireDay = new Date();
                    expireDay.setDate(today.getDate() + 365);
                    cookie.save("token", response.token, { path: "/", expires: expireDay });
                    localStorage.removeItem(CONSTANTS.LOGIN_URL_CALLBACK);
                    setIsLoading(false);
                    window.location.href = redirect;
                } else {
                    Notify(NOTIFY.ERROR, "Lỗi", CONSTANTS.MSG_ERROR);
                    localStorage.removeItem(CONSTANTS.LOGIN_URL_CALLBACK);
                    window.location.href = "/login"
                }
            } else {
                if (err.data) {
                    Notify(NOTIFY.ERROR, "Lỗi", err.data);
                    localStorage.removeItem(CONSTANTS.LOGIN_URL_CALLBACK);
                    window.location.href = "/login"
                }
                else{
                    Notify(NOTIFY.ERROR, "Lỗi", CONSTANTS.MSG_ERROR);                    
                    localStorage.removeItem(CONSTANTS.LOGIN_URL_CALLBACK);
                    window.location.href = "/login"
                } 
            }
        }
        setIsLoading(false);
    }

    return (
        <div>
            <LoadingR fullScreen={true} isShow={isLoading} />
        </div>
    );
}

LoginCallback.propTypes = {};

export default LoginCallback;



// WEBPACK FOOTER //
// ./src/artist-ui/LoginCallback.js